import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdsWithPromosLoading = (isLoading) => ({
  type: actionTypes.SET_ADS_WITH_PROMOS_LOADING,
  payload: isLoading
})
